import React from 'react';
import { Route, useLocation, Redirect, Switch } from 'react-router-dom';
// import { CSSTransitionGroup, CSSTransition, TransitionGroup } from 'react-transition-group';

// Import Theme
import { ThemeProvider } from "styled-components"

// Importing NavMenuData
import { navMenuData } from './data/websiteData';
import { contactUsData } from './data/websiteData';

import Navbar from './components/Navbar';
import ContactUsInfo from './components/ContactUsInfo';

import './App.scss';
// import HeaderInfo from './components/header/Header';
import Home from './pages/Home/Home';
import Products from './pages/Products';
import Services from './pages/Services';
import Platform from './pages/Platform';
import Industries from './pages/Industries';
import AboutUs from './pages/AboutUs';
import { AnimatePresence } from "framer-motion";
import px2vw from './utils/px2vw';

// const siteName = "Qberaa"

var theme = {
  bgColor: "white",
  logoFontFamily: "'Open Sans', sans-serif",
  secfontFamily : "Roboto",
  fontFamily:  "'Open Sans', sans-serif", 
  fontStyle: "normal",
  color: "black",
  pFontSize: px2vw(16) ,
  pLineHeight : px2vw(28),
  titleLineHeight : px2vw(60),
  subtitleFontSize : px2vw(16),
  subtitleLetterSpacing : "0px",
  subHeaderFontSize : px2vw(20),
  cardFontSize : px2vw(20),
  paddingLeft:  px2vw(200),
  paddingRight: px2vw(200),
}

//given 600 considering the rotation of mobile as well.
if( window.innerWidth <= 600) {
  theme = {
    bgColor: "white",
    logoFontFamily: "'Open Sans', sans-serif", 
    fontFamily:  "'Open Sans', sans-serif", 
    secfontFamily : "Roboto",
    fontStyle: "normal",
    color: "black",
    titleLineHeight : px2vw(120),
    subHeaderFontSize : px2vw(54.21),
    cardFontSize : px2vw(64.21),
    pFontSize : px2vw(66),
    pLineHeight : px2vw(100),
    mobTitleFontSize : px2vw(14),            
    mobCommonTitleFontSize : "20px",       
    subtitleFontSize : px2vw(36),
    subtitleLetterSpacing : "1px",
  }
}

function App() {
  const location = useLocation();
  return (
    <>
      <ThemeProvider theme={theme}>
      <Navbar data={navMenuData}></Navbar>  
        <AnimatePresence exitBeforeEnter>
            <Switch location={location} key={location.pathname}>
              <Route exact path="/"><Redirect to="/home" /></Route>
              <Route path="/Home"><Home /></Route>
              <Route path="/AboutUs"><AboutUs /></Route>
              <Route path="/GetInTouch"><AboutUs /></Route>
              <Route path="/services/:id" component={Services}/>
              <Route path="/products/:id" component={Products}/>
              <Route path="/platform/:id" component={Platform}/>
              <Route path="/industries/:id" component={Industries}/>
            </Switch>
        </AnimatePresence>
        <ContactUsInfo> </ContactUsInfo> 
      </ThemeProvider>
    </>
  );
}

export default App;
